import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { PrintagentService } from '../../../service/printagent/printagent.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

declare const cwebclient:any;

@Component({
  selector: 'app-root',
  templateUrl: 'wa9201.component.html',
  styleUrls: ['wa9201.component.scss']
})

export class Wa9201Component implements DoCheck {
  public componentTitle = 'WA9201:プリンタ設定マスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public disable: boolean = true;
  public printagents: any;
  public printagentdisplayTx = new FormControl();
  public filteredPrintagentOptions: Observable<string[]>;

  // for error message
  public errorInfo: string = '';
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public printagentCd = new FormControl();
  public printagentTx = new FormControl('', [
    Validators.maxLength(validation.printagentTx.maxLength),
  ]);
  // build FormGroup
  myForm = this.builder.group({
    printagentTx: this.printagentTx,
  });
  private isShowPrintagentList = false;
  private isInput = false;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private printagentService: PrintagentService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    // 印刷設定取得
    if (localStorage.getItem(`printagentCd`) !== null) {
      this.printagentCd.setValue(localStorage.getItem(`printagentCd`));
    }
    if (localStorage.getItem(`printagentTx`) !== null) {
      this.printagentTx.setValue(localStorage.getItem(`printagentTx`));
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  ngDoCheck() {

  }

  onView() {
    this.printagentService
    .get()
    .then(outputJson => {
      console.log(JSON.stringify(outputJson));
      this.printagents = outputJson.printagents;
      this.filteredPrintagentOptions = this.printagentdisplayTx.valueChanges.startWith(null).map(val => (this.printagentfilter(val)));

    })
  }

  printagentfilter(val: string): string[] {

    if (val != null && val.length > 0) {
      return this.printagents.filter(pa => pa.printagentTx.indexOf(val) !== -1);
    }
    return this.printagents;
  }

  printagentCdfilter(val: string): string[] {

    if (val != null && val.length > 0) {
      return this.printagents.filter(pa => pa.printagentCd.indexOf(val) !== -1);
    }
    return this.printagents;
  }

  printerNmOnFocus() {
    setTimeout(() => {
      this.isShowPrintagentList = true;
    })
  }

  printerNmOnBlur() {
    setTimeout(() => {
      this.isShowPrintagentList = false;
      if (this.printagentTx.value == '') {
        this.printagentCd.setValue('');
      }
    })
  }

  printerNmOnKeydown() {
    setTimeout(() => {
      let printagentTx = this.printagentTx.value;
      if (printagentTx == '') {
        this.printagentCd.setValue('');
      }
    }, 100)
  }

  printerNmOnChange(printagent) {
    let printagentCd = printagent.target.value;
    let result = this.printagentCdfilter(printagentCd);
    if (printagentCd != '' && result.length > 0) {
      this.printagentTx.setValue(result[0]['printagentTx']);
      this.printagentCd.setValue(result[0]['printagentCd']);
    }
  }

  onClear() {
    this.printagentTx.setValue('');
    this.printagentCd.setValue('');
  }

  //クライアント印刷テスト
  kickPrintClientReport(reportCd){
    console.log("kickPrintClientReport");
    cwebclient.ChangePrintInfo(reportCd);//印刷設定変更メソッドの呼び出し
  }

  isClearUpdate(): boolean {
    return this.printagentTx.value == ''
    && this.printagentCd.value == ''
  }

  update() {

    if (this.isClearUpdate()) {
      this.printagentCd.setValue('');
      this.printagentTx.setValue('');
      localStorage.removeItem('printagentCd');
      localStorage.removeItem('printagentTx');    
      sessionStorage.setItem('SuccessInfoMessage', 'プリンタ設定を更新しました。');

    } else if (this.printagentTx.value != '' && this.printagentCd.value == '') {
      this.errorInfo = '更新に失敗しました。端末名をクリアするか、制御端末を選択してください。';
    } else if (this.printagentTx.value.length > 50) {
      this.errorInfo = '端末名は50文字以内で入力してください。';
    } else {
      const param = {
        printagentCd: this.printagentCd.value
        , printagentTx: this.printagentTx.value
        , updprogramCd: 'wa9201'
      }
  
      this.printagentService
      .update(param)
      .then(outputJson => {
        sessionStorage.setItem('SuccessInfoMessage', 'プリンタ設定を更新しました。');
        localStorage.setItem(`printagentCd`, this.printagentCd.value);
        localStorage.setItem(`printagentTx`, this.printagentTx.value);
        this.errorInfo = '';
  
        this.onView();
      })
      .catch(error =>{
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    }
  }
}




// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9201/wa9201.component.ts